import {
  GET_ALL_USERS,
  GET_ALL_USERS_ERROR,
  GET_CERTAIN_USER,
  GET_CERTAIN_USER_ERROR,
  GET_COUNT_ALL_USERS,
  GET_COUNT_ALL_USERS_ERROR,
  UPDATE_CERTAIN_USER,
  UPDATE_CERTAIN_USER_ERROR,
  DELETE_CERTAIN_USER,
  DELETE_CERTAIN_USER_ERROR
} from "../types";

import * as api from "../../api/axiosBase";

// get all users data action
export const getAllUsers =
  (page: any, limit: any, query: string) => async (dispatch) => {
    try {
      const { data } = await api.getAllUsers(page, limit, query);
      dispatch({
        type: GET_ALL_USERS,
        payload: data.data.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_USERS_ERROR,
        payload: error.response.data.message
      });
    }
  };

// get certain User
export const getCertainUser = (id: string, history) => async (dispatch) => {
  try {
    const { data } = await api.getCertainUser(id);
    dispatch({
      type: GET_CERTAIN_USER,
      payload: data.data.data
    });
    history.push("/user-profile");
  } catch (error) {
    dispatch({
      type: GET_CERTAIN_USER_ERROR,
      payload: error.response.data.message
    });
  }
};

// update certain user
export const updateCertainUser =
  (formData: any, id, history) => async (dispatch) => {
    try {
      const { data } = await api.updateCertainUser(formData, id);
      dispatch({ type: UPDATE_CERTAIN_USER, payload: data });
      dispatch(getCertainUser(id, history));
    } catch (error) {
      dispatch({
        type: UPDATE_CERTAIN_USER_ERROR,
        payload: error.response.data
      });
    }
  };

// deleteCertainUser
export const deleteCertainUser = (id, history) => async (dispatch) => {
  try {
    const { data } = await api.deleteCertainUser(id);
    dispatch({ type: DELETE_CERTAIN_USER, payload: data });
    dispatch(getCertainUser(id, history));
    history.push("/all-users");
  } catch (error) {
    dispatch({
      type: DELETE_CERTAIN_USER_ERROR,
      payload: error.response.data
    });
  }
};
// get count all users
export const getCountAllUsers = (query: any) => async (dispatch) => {
  try {
    const { data } = await api.getCountAllUsers(query);
    dispatch({
      type: GET_COUNT_ALL_USERS,
      payload: data.data.data
    });
  } catch (error) {
    dispatch({
      type: GET_COUNT_ALL_USERS_ERROR,
      payload: error.response.data.message
    });
  }
};
